var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 61 25"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ibm_svg__a",
    d: "M.09.102h9.907v1.774H.09z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ibm_svg__c",
    d: "M.39.102h16.852v1.774H.39z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ibm_svg__e",
    d: "M0 25h60.153V.102H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#868C98",
    d: "M50.782 0l-.626 2.083h10.166V0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.37)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ibm_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ibm_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.388.102l.609 1.774c.004-.003-9.903.002-9.903 0C.094 1.873.09.103.091.103L9.388.102z",
    fill: "#868C98",
    mask: "url(#ibm_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.835)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ibm_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ibm_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.243.103c1.533.15 2.864.71 3.999 1.773H.39V.102h12.852z",
    fill: "#868C98",
    mask: "url(#ibm_svg__d)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "ibm_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ibm_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#868C98",
    mask: "url(#ibm_svg__f)",
    d: "M.001 1.872h11.707V.102H0zM60.154 5.194H48.993s.609-1.761.605-1.762h10.556v1.762zM44.517 5.196H33.46V3.432h10.451zM31.389 3.432c.222.581.485 1.079.485 1.76H13.229v-1.76h18.16zM.001 5.193h11.707V3.432H0zM47.852 8.523l.613-1.77 8.38.002V8.52zM45.054 6.753l.61 1.77h-8.907v-1.77zM32.021 6.752c0 .607-.074 1.24-.246 1.77H26.67v-1.77h5.351zM3.264 8.522h5.032v-1.76H3.264zM16.616 8.522h5.022v-1.77h-5.022zM41.705 10.434s.002 1.34 0 1.342h-4.948v-1.761h9.43l.585 1.642c.002 0 .564-1.646.566-1.642h9.503v1.761h-4.924l-.003-1.342-.455 1.342-9.3-.003-.454-1.34zM16.616 10.014h14.418a6.607 6.607 0 01-1.43 1.762s-12.99.002-12.99 0l.002-1.762M3.264 11.776h5.032v-1.762H3.264zM51.917 15.097h4.924v-1.761h-4.924zM41.705 13.335h-4.948v1.762h4.95c0-.001.005-1.762-.002-1.762M50.923 13.335c-.023-.003-.577 1.76-.6 1.762l-7.014.003c-.006-.003-.617-1.768-.617-1.765h8.23zM16.614 13.335H29.58a8.63 8.63 0 011.545 1.762h-14.51v-1.762M8.295 15.096v-1.761H3.273v1.76l5.022.001M51.917 18.418h4.923v-1.761h-4.923zM36.757 18.418h4.947v-1.761h-4.947zM49.171 18.426c.001-.008.607-1.771.617-1.77h-5.963c-.01 0 .611 1.762.611 1.762s4.734.016 4.735.008M16.615 18.417v-1.762h5.098s.004 1.763 0 1.763c-.005 0-5.098-.003-5.098 0M31.84 16.656c.247.53.272 1.163.321 1.77H26.76v-1.77h5.08zM3.273 18.417h5.023v-1.761H3.273zM51.917 21.671h8.236V19.91h-8.236zM33.46 21.671h8.244V19.91H33.46zM48.063 21.67h-2.515l-.603-1.762h3.7zM0 19.908v1.762H11.7c.005.003-.005-1.76 0-1.76L0 19.908M31.947 19.908c-.123.582-.236 1.29-.65 1.763H13.228v-1.763h18.72zM46.923 24.996h-.231l-.588-1.766h1.422zM51.917 25h8.236v-1.77h-8.236zM13.225 24.996v-1.764l16.95.002c-1.134 1.114-2.691 1.741-4.368 1.766l-12.58-.004M33.46 25h8.244v-1.77H33.46zM11.7 23.238s-.006 1.758 0 1.758c.004 0-11.696.007-11.699.003-.003-.003.003-1.766 0-1.766s11.693.01 11.698.005"
  })))));
}

export default __webpack_public_path__ + "static/ibm.6b8eb2c0.svg";
export { SvgIbm as ReactComponent };